import { useInView } from 'react-intersection-observer';

import { PaymentMethodMessagingElement } from '@stripe/react-stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { config } from 'config';
import { getCSSColor } from 'themes/helpers';

import { getStripePaymentMethodTypes } from 'hooks/bnpl/utils';
import { EdgeBNPLCapabilities } from 'hooks/payment/bnplCapabilities/useBnplCapabilities';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import styles from './BuyNowPayLaterPromo.module.css';

const stripePromise = loadStripe(config.stripePubKey, { locale: 'en' });

export const BuyNowPayLaterPromo = ({
  unitAmount,
  textAlign,
  textColor,
  backgroundColor,
  paymentMethodTypes,
}: {
  unitAmount: number;
  textAlign?: 'left' | 'right' | 'center';
  textColor?: string;
  backgroundColor?: string;
  paymentMethodTypes?: EdgeBNPLCapabilities[];
}) => {
  const { theme: { palette } = {} } = useGGTheme();
  const { ref, inView } = useInView({
    threshold: 0,
  });

  const textPrimary = textColor || getCSSColor(palette?.textPrimary);
  const backgroundPrimary = backgroundColor || getCSSColor(palette?.bgPrimary);

  return (
    <div className={styles.bnplPromo} ref={ref}>
      {inView ? (
        <Elements
          stripe={stripePromise}
          options={{
            loader: 'always',
            appearance: {
              variables: {
                colorText: textPrimary,
                colorBackground: backgroundPrimary,
              },
              rules: {
                '.PaymentMethodMessaging': {
                  textAlign: textAlign || 'left',
                },
              },
            },
          }}
        >
          <PaymentMethodMessagingElement
            className={styles.paymentMethodMessagingElement}
            options={{
              amount: unitAmount,
              currency: 'USD',
              countryCode: 'US',
              paymentMethodTypes:
                getStripePaymentMethodTypes(paymentMethodTypes),
            }}
          />
        </Elements>
      ) : null}
    </div>
  );
};
